"use strict";

angular.module("licensure.services").factory("EXSkill", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/EXSkill", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getActive: function () {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/EXSkill/", {
                        params: { checkActive: true}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getskill: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSkill/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            updateActive: function (examSkillIDs, status) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation + "/api/ExamModule/ExamSkills/BatchActive",
                        {
                            examSkillIDs: examSkillIDs,
                            status: status
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            updateCritical: function (ids, status) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation + "/api/ExamModule/ExamSkills/BatchCritical",
                        {
                            examSkillIDs: ids,
                            status: status
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            updateCategory: function (ids, category) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation + "/api/ExamModule/ExamSkills/BatchCategory",
                        {
                            examSkillIDs: ids,
                            category: category
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (skill, options) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/EXSkill/";
                if (!isUndefined(skill.id)) {
                    method = "PUT";
                    url += skill.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        skill: skill,
                        options: options
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/EXSkill/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
